import type { Language } from 'app/lib/language';
import type { ListingType, ListingsSortBy } from './listing';

export enum QuickOfferBannerType {
  nonHideable = 'non-hideable',
  hideable = 'hideable',
  hidden = 'hidden',
}

export enum TrialModalType {
  never = 'never',
  once = 'once',
  always = 'always',
}

export const AddToCalendar = {
  always: 'always',
  once: 'once',
  never: 'never',
} as const;
export type AddToCalendarType = (typeof AddToCalendar)[keyof typeof AddToCalendar];

export interface LastExplorationDate {
  [ListingType.offer]?: string;
  [ListingType.request]?: string;
}

export enum SharerType {
  borrower = 'borrower',
  lender = 'lender',
  both = 'both',
}

export interface PreferenceNameToValue {
  language: Language;
  conciergerieOff: boolean;
  pushNotificationsForChat: boolean;
  emailForUnseenChannel: boolean;
  smsForChat: boolean;
  pushNotificationsForNeed: boolean;
  pushNotificationsForNeedDisabledGroups: { type: 'group' | 'address'; id: string }[];
  emailForNeed: boolean;
  emailForNeedDisabledGroups: { type: 'group' | 'address'; id: string }[];
  emailForWeeklyOffers: boolean;
  pushNotificationForWeeklyOffers: boolean;
  pushNotificationsForUrgentOffers: boolean;
  emailForUrgentOffers: boolean;
  smsForUrgentOffers: boolean;
  pushNotificationsForInterests: boolean;
  emailForInterests: boolean;
  smsForInterests: boolean;
  trialModal: TrialModalType;
  quickOfferBanner: QuickOfferBannerType;
  lastExplorationDate: LastExplorationDate;
  addToCalendar: AddToCalendarType;
  searchDistance: number;
  searchCenterLatitude: number;
  searchCenterLongitude: number;
  tutorialsCompleted: string[];
  sortOffers: ListingsSortBy;
  sortNeeds: ListingsSortBy;
  sortServices: ListingsSortBy;
  preferredCategories: string[];
  sharerType: SharerType;
}

export type PreferenceName = keyof PreferenceNameToValue;

export interface Preference<T extends PreferenceName> {
  name: T;
  value: PreferenceNameToValue[T];
}
